import { Component, inject } from '@angular/core';
import { StageService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  StageCreateDto,
  StageDto,
  StageExcelDownloadDto,
  StageUpdateDto,
} from '../proxy/controlling/dtos/stage';
import { STAGE_CONFIG, STAGE_FIELDS } from './stage.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-stage',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, StageService, ConfirmationService],
  templateUrl: './stage.html',
  styleUrl: './stage.scss',
})
export class Stage extends BaseCrudComponent<
  StageDto,
  StageCreateDto,
  StageUpdateDto,
  StageExcelDownloadDto
> {
  service = inject(StageService);
  config = STAGE_CONFIG;
  fields = STAGE_FIELDS;

  protected prepareUpdateDto(data: any, selected: StageDto): StageUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Stage';
  }
}
